import React from 'react';
import Accordion from 'core/components/Accordion';
import {
  Props,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';
import {
  Props as FieldsArrayWrapperProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import AllergyInfoItem from 'pages/Dashboard/pages/Charts/pages/Details/components/GenericSection/AllergyInfoItem';
import FamilyMedicalInfoItem from 'pages/Dashboard/pages/Charts/pages/Details/components/GenericSection/FamilyInfoItem';
import MedicalHistoryInfoItem from 'pages/Dashboard/pages/Charts/pages/Details/components/GenericSection/MedicalHistoryInfoItem';
import SurgeryInfoItem from 'pages/Dashboard/pages/Charts/pages/Details/components/GenericSection/SurgeryInfoItem';
import SocialHistories from 'pages/Dashboard/pages/Charts/pages/Details/components/SocialHistories';
import SortableFieldsArrayWrapper from 'pages/Dashboard/pages/Charts/pages/Details/components/SortableFieldsArrayWrapper';

const defaultAllergyData = Object.freeze({ source: '', reaction: '' });
const defaultFamilyHistoryData = Object.freeze({ diseaseName: '', familyRelation: 'Parent' });
const defaultMedicalHistoryData = Object.freeze({ conditionName: '' });
const defaultSurgicalHistoryData = Object.freeze({ surgeryName: '', surgeryYear: null });

export const historySections: FieldsArrayWrapperProps[] = [{
  FieldComponent: AllergyInfoItem,
  getDefaultValue: () => defaultAllergyData,
  formKey: 'nonDrugAllergies',
  title: 'Non-Drug Allergies',
  append: { text: 'Add Non-Drug Allergy' },
}, {
  FieldComponent: SurgeryInfoItem,
  getDefaultValue: () => defaultSurgicalHistoryData,
  formKey: 'surgicalHistories',
  title: 'Surgical History',
  append: { text: 'Add Surgery' },
}, {
  FieldComponent: MedicalHistoryInfoItem,
  getDefaultValue: () => defaultMedicalHistoryData,
  formKey: 'medicalHistories',
  title: 'Medical History',
  append: { text: 'Add Medical History' },
}, {
  FieldComponent: FamilyMedicalInfoItem,
  getDefaultValue: () => defaultFamilyHistoryData,
  formKey: 'familyHistories',
  title: 'Family History',
  append: { text: 'Add Family Medical History' },
}];

const accordionProps = {
  defaultExpanded: true,
  disableGutters: true,
  headerClasses: {
    root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
    content: '!m-0',
  },
  detailsClasses: { root: '!p-2 populate-form gap-4 flex flex-col w-full' },
};

export default function PatientHistory({ patient }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <Accordion
        header="Social History"
        {...accordionProps}
      >
        <SocialHistories patient={patient} />
      </Accordion>
      {historySections.map(({ title, ...sectionProps }) => (
        <Accordion
          key={sectionProps.formKey}
          header={title}
          {...accordionProps}
        >
          <SortableFieldsArrayWrapper
            key={sectionProps.formKey}
            {...sectionProps}
            patient={patient}
          />
        </Accordion>
      ))}
      <div className="!h-0" />
    </div>
  );
}
